import type { GetCustomDatasourceByIdResponseRow } from '@risksmart-app/trpc/src/types';
import type { GetCustomDatasourceByIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetCustomDatasourceByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetCustomDatasourceByIdArgs = {
  id: string;
};

export const useGetCustomDatasourceById = createQueryHook<
  UseGetCustomDatasourceByIdArgs,
  GetCustomDatasourceByIdResponseRow | null,
  GetCustomDatasourceByIdQuery
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.customDatasource.customDatasourceById.queryOptions({ id }),
  mapTrpcDataToGraphQL: (data) => ({
    // CreatedByUser is DB-nullable but non-null on the legacy GraphQL shape —
    // coalesce to keep the generated contract (a null would have errored on
    // the Hasura path too).
    custom_datasource_by_pk: data
      ? { ...data, CreatedByUser: data.CreatedByUser ?? '' }
      : null,
  }),
  graphqlDocument: GetCustomDatasourceByIdDocument,
  graphqlVariables: ({ id }) => ({ Id: id }),
  // Mounted by several concurrent consumers (detail/update pages + breadcrumb
  // hook); cache-first lets Apollo dedup so vitest doesn't promote a no-cache
  // console.warn to fatal.
  graphqlFetchPolicy: 'cache-first',
});
